import env from "../util/environment";
import UrlParams from "../util/url_params";

/**
 * It's copy-past from pc.warface.com
 * @returns {{top: number, left: number, width: number, height: number}}
 */
function getWindowPosition() {
  let w = 504,
    h = 500;

  let dualScreenLeft =
      typeof window.screenLeft !== "undefined" ? window.screenLeft : window.screenX,
    dualScreenTop = typeof window.screenTop !== "undefined" ? window.screenTop : window.screenY,
    width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width,
    height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height,
    systemZoom = width / window.screen.availWidth,
    left = (width - w) / 2 / systemZoom + dualScreenLeft,
    top = (height - h) / 2 / systemZoom + dualScreenTop - 100;
  return {
    left,
    top,
    width: w / systemZoom,
    height: h / systemZoom,
  };
}
class OauthManager {
  constructor() {
    this.base_url = "https://account.my.games/oauth2/";
    this.oauth_window = null;
    this.oauth_method = "signup";
  }
  showWindow(signup = false) {
    let method = signup ? "signup" : "signin";
    if (this.oauth_window && !this.oauth_window.closed) {
      if (method !== this.oauth_method) {
        this.oauth_window.location = this.getOauthUrl(signup);
      }
      this.oauth_window.focus();
    } else {
      this.oauth_window = window.open(this.getOauthUrl(signup), "Account", this.getWindowParams());
    }
  }
  getOauthUrl(signup = false) {
    return this.base_url + "?" + UrlParams.urlFromObject(this.getUrlParams(signup));
  }
  getUrlParams(signup = false) {
    let params = {
      client_id: window.__GEMS.client_id,
      redirect_uri: this.getRedirectUrl(),
      response_type: "code",
      signup_method: window.__GEMS.signup_method,
      signup_social: window.__GEMS.signup_social,
      lang: env.getPosixLocale(),
      gc_id: window.__GEMS.gc_id,
    };
    if (signup) {
      params.signup = 1;
    }
    return params;
  }
  getWindowParams() {
    let params = Object.assign(
      {
        resizable: "no",
        scrollbars: "no",
        toolbar: "no",
        menubar: "no",
        directories: "no",
        location: "no",
      },
      getWindowPosition()
    );
    return UrlParams.urlFromObject(params, ",");
  }

  getRedirectUrl() {
    return location.origin + "/dynamic/auth/?o2=1";
  }
}
export default new OauthManager();
